import template from "./template.html.twig";
import "./style.scss";

Shopware.Component.register("neti-ior-email-log-sidebar-filter", {
    template,

    inject: [
        "acl"
    ],

    data(){
        return {
            filterCount: 0,
            filter : {
                mailed : -1,
                email : null,
                conditions : [],
                createdAt: { from: null, to: null },
            },
            mailedOptions: [
                {
                    value: -1,
                    label: this.$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.mailed.none')
                },
                {
                    value: true,
                    label: this.$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.mailed.true')
                },
                {
                    value: false,
                    label: this.$t('neti-incomplete-order-reminder.mail-log.list.sidebar-filter-email-log.mailed.false')
                }
            ],
            conditionOptions : [
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.all'),
                    value : null,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.consent'),
                    value : 1,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.blackList'),
                    value : 2,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.success'),
                    value : 3,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.orderSince'),
                    value : 4,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.reminded'),
                    value : 5,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.newsletter'),
                    value : 6,
                },
                {
                    label : this.$t('neti-incomplete-order-reminder.condition.rule'),
                    value : 7,
                },
            ]
        };
    },

    methods : {
        onResetFilters() {
            this.filter = {
                mailed : -1,
                email : null,
                conditions: [],
                createdAt: { from: null, to: null }
            };

            this.onUpdateFilters();
        },

        onUpdateFilters() {
            const filters = this.collectFilters();

            this.$emit("change", filters);
            this.filterCount = Object.keys(filters).length;
        },

        collectFilters() {
            const filters = {};

            if (this.filter.email !== "" && this.filter.email !== null) {
                filters.email = this.filter.email;
            }

            if(Array.isArray(this.filter.conditions) && this.filter.conditions.length > 0)
            {
                if(!this.filter.conditions.includes(null)) {
                    filters.conditions = this.filter.conditions;
                }
            }

            if (parseInt(this.filter.mailed) !== -1) {
                filters.mailed = this.filter.mailed;
            }

            if (this.filter.createdAt.to !== null) {
                filters.createdTo = this.filter.createdAt.to;
            }

            if (this.filter.createdAt.from !== null) {
                filters.createdFrom = this.filter.createdAt.from;
            }

            return filters;
        },
    }
});